export default __webpack_public_path__ + "static/media/shareDrive.b2ed304c.svg";